import React from "react";
import AccessibilitatModal from "./AccessibilitatModal";
import { Icon } from "antd";
import styles from "./Peu.module.css";
import novaFinestra from "../images/novafinestra.png";

const Peu = () => (
  <div className={styles.peu}>
    <span className={styles.mail}>
      <Icon type="mail" />{" "}
      <a href="mailto:fenocat.meteocat@gencat.cat">
        fenocat.meteocat@gencat.cat
      </a>
    </span>
    <span className={styles.avis}>
      <a
        href="https://www.meteo.cat/wpweb/avis-legal/"
        target="_blank"
        rel="noopener noreferrer"
        title="Avís legal (obre en finestra nova)"
      >
        Avís Legal
        <img src={novaFinestra} alt="(Obre en finestra nova)" />
      </a>
    </span>
    <span className={styles.politica}>
      <a
        href="https://www.meteo.cat/wpweb/politica-de-privacitat/"
        target="_blank"
        rel="noopener noreferrer"
        title="Política de privacitat (obre en finestra nova)"
      >
        Política de privacitat
        <img src={novaFinestra} alt="(Obre en finestra nova)" />
      </a>
    </span>
    <span className={styles.accessibilitat}>
      <AccessibilitatModal />
    </span>
    <span className={styles.meteocat}>
      &copy; Servei Meteorol&ograve;gic de Catalunya
    </span>
  </div>
);

export default Peu;
